import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "9",
  fill: "none",
  viewBox: "0 0 8 9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7A869F",
      d: "M8 7.93a1 1 0 0 1-1.5.866l-6-3.464A1 1 0 0 1 .5 3.6l6-3.465a1 1 0 0 1 1.5.866z"
    }, null, -1)
  ]))]))
}
export default { render: render }